import React from "react";
import { useTranslation } from "react-i18next";
import OInputField from "../../components/reusable/OInputField";
import OTextArea from "../../components/reusable/OTextArea";

const BasicStep = ({ register, errors, setValue, watch, permission, user }) => {
  const { t } = useTranslation();

  const title = watch?.("title") || "";
  const titleAr = watch?.("titleAr") || "";
  const desc = watch?.("description") || "";
  const descAr = watch?.("descriptionAr") || "";

  const handleTrim = (name) => (e) => {
    const v = (e?.target?.value || "").trim();
    setValue?.(name, v, { shouldValidate: true, shouldDirty: true });
  };

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <div>
        <OInputField
          inputLabel={t("O_TITLE")}
          name="title"
          type="text"
          disabled={!(permission?.add || user?.role === "admin")}
          placeholder={t("Enter job title") || "Enter job title"}
          register={register("title", {
            required: t("Title is required") || "Title is required",
          })}
          errors={errors}
          requiredMark
          onBlur={handleTrim("title")}
        />
        <div className="text-xs text-gray-500">{title.length}/120</div>
      </div>
      <div>
        <OInputField
          inputLabel={t("TITLE_AR")}
          name="titleAr"
          type="text"
          disabled={!(permission?.add || user?.role === "admin")}
          placeholder={t("Enter Arabic job title") || "Enter Arabic job title"}
          register={register("titleAr")}
          errors={errors}
          onBlur={handleTrim("titleAr")}
        />
        <div className="text-xs text-gray-500">{titleAr.length}/120</div>
      </div>
      <div className="md:col-span-2">
        <OTextArea
          inputLabel={t("STATIC_DESCRIPTION")}
          name="description"
          placeholder={t("Enter job description") || "Enter job description"}
          disabled={!(permission?.add || user?.role === "admin")}
          register={register("description", {
            required: t("Description is required") || "Description is required",
          })}
          errors={errors}
          requiredMark
          onBlur={handleTrim("description")}
        />
        <div className="text-xs text-gray-500">{desc.length}/1000</div>
      </div>
      <div className="md:col-span-2">
        <OTextArea
          inputLabel="Description (Ar)"
          name="descriptionAr"
          placeholder={
            t("Enter Arabic description") || "Enter Arabic description"
          }
          disabled={!(permission?.add || user?.role === "admin")}
          register={register("descriptionAr")}
          errors={errors}
          onBlur={handleTrim("descriptionAr")}
        />
        <div className="text-xs text-gray-500">{descAr.length}/1000</div>
      </div>
    </div>
  );
};

BasicStep.fields = ["title", "description"];

export default BasicStep;
